<template>
  <div :id="!mobiTablet ? 'header' : 'header-mobile'">
    <div class="container-fluid fill-height" v-if="!mobiTablet">
      <v-layout v-if="user" class="fill-height">
        <div class="d-flex justify-space-between align-center fill-height" style="width: 200px;">
          <a href="/hotel/dashboard">
            <img
              class="logo"
              :src="!dataMain ? logoCrs : dataMain.logo"
              height="47px"
              alt
            />
          </a>
        </div>
        <div class="d-flex justify-space-between align-center fill-height" :style="`width: calc( 100vw - 200px)`" >
          <div class="title">
              {{$t('CHANNEL_MANAGER_SYSTEM')}}
          </div>
          <div class="d-flex">
            <div class="menu" >
              <img
                :src="languageUrl"
                width="24"
                height="24"
                alt="vi"
                class="lang"
              />

              <ul class="language">
                <li
                  v-for="(lang, index) in languageList"
                  :key="`languageList_${index}`"
                  class="d-flex align-center cursor"
                  @click="changeLanguage(lang.languageCode)"
                >
                  <span>
                    <img
                      :src="`https://static.oneinventory.com${lang.flagUrl}`"
                      width="24"
                      height="24"
                      alt
                    />
                  </span>
                  <span>{{ lang.name }}</span>
                </li>
              </ul>
            </div>
            <div class="menu" @click="changeDrawer()">
              <img class="avatar" v-if="!user.avatar" src="@/assets/svg/account-circle.svg" alt />
              <img class="avatar" v-else :src="user.avatar" alt />
              <div class="d-flex flex-column ml-3">
                <span>{{ user.fullName }}</span>
                <span class="user-group">{{ user.group }}</span>
              </div>
              <!-- <ul>
                <li class="d-flex align-center cursor" @click="goToPersonalSetting">
                  <span class="icon icon-Account"></span>
                  <span>{{ $t("PERSONAL_ACCOUNT_SETTING") }}</span>
                </li>
                <li class="d-flex align-center cursor" @click="logout">
                  <span class="icon icon-Logout"></span>
                  <span>{{ $t("LOG_OUT") }}</span>
                </li>
                <li class="d-flex align-center cursor" @click="changeDevice()" v-if="isMobiTablet && !mobiTablet">
                  <v-icon class="icon mr-3 text-primary">desktop_access_disabled</v-icon>
                  <span>{{ $t("VIEW_MOBILE_VERSION") }}</span>
                </li>
              </ul> -->
            </div>
          </div>
        </div>
      </v-layout>
    </div>
    <div v-else class="pl-3 pr-3 fill-height">
       <v-layout v-if="user" class="fill-height d-flex justify-content-start align-items-center">
        <div class="d-flex align-center fill-height">
          <a href="/hotel/dashboard">
            <img
              class="logo"
              :src="!dataMain ? logoCrs : dataMain.logo"
              height="24px"
              alt
            />
          </a>
        </div>
        <div class="fs-15 ml-3">
            <strong>{{$t('CHANNEL_MANAGER_SYSTEM')}}</strong>
        </div>
      </v-layout>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import { authenticationService } from "@/_services";
import eventBus from "@/_helpers/event-bus.js";
import { service } from "@/_services/Account/Setting/account-setting.service.js";
import logoCrs from '@/assets/ezCrs-ngang.png';
import { service as generalSetting } from "@/_services/HotelSetting/general-setting.service.js";

export default {
  data() {
    return {
      sysLang: this.$i18n.locale,
      user: null,
      userLogin: JSON.parse(localStorage.getItem("currentUser")).user.username,
      hideSidebar: false,
      logoCrs: logoCrs,
      languageList: JSON.parse(localStorage.getItem("listI18ns") || '[]')
    }
  },
  created() {
    this.reloadCurrentUser();
    eventBus.$on("EVENT_RELOAD_USER", () => this.reloadCurrentUser());

    // Xoá kênh OTA và filter đã chọn khi chuyển sang màn hình chuỗi.
    // localStorage.removeItem("currentFilterRoomSale");
    localStorage.removeItem("currentOTARoomSale");
  },
  mounted() {
    if (!localStorage.getItem('listI18ns')) {
      this.getLanguageList();
    }
  },
  computed: {
    languageUrl() {
      return require(`@/assets/flags/${this.$i18n.locale}.png`);
    },
  },
  methods: {
    async getLanguageList() {
      await generalSetting.getLangs().then(res => {
        if (res.responseCode == 0) {
          this.languageList = res.data;
          localStorage.setItem("listI18ns", JSON.stringify(res.data));
        }
      });
    },
    changeDrawer() {
      this.$emit('changeDrawerAplication')
    },
    changeDevice() {
      localStorage.setItem("device", 'MOBILE');
      this.$router.push({ name: 'chain-list' });
      location.reload();
    },
    toggleMenu(){
      if ( this.hideSidebar ) {
        this.hideSidebar = false;
        document.getElementById('left-menu').classList.remove('hide-sidebar');
        document.getElementsByClassName('right-page-content').item(0).classList.remove('hide-sidebar');
      } else {
        this.hideSidebar = true;
        document.getElementById('left-menu').classList.add('hide-sidebar');
        document.getElementsByClassName('right-page-content').item(0).classList.add('hide-sidebar');
      }
    },
    logout() {
      if (this.domain.includes('ezcrs') || this.domain.includes('ezcms') || (this.dataMain && this.dataMain.isLoginAdmin === false)) {
        this.$oidc.signoutRedirect();
        authenticationService.logout();
        this.$router.push({ name: "login" });
        location.reload();
      } else {
        // authenticationService.logout();
        localStorage.removeItem("currentUser");
        this.$router.push({ name: "login-admin" });
      }
      
    },
    goToPersonalSetting() {
      this.$router.push({ name: "accountSetting" });
    },
    changeLanguage(lang) {
      localStorage.setItem("systemLanguage", lang);
      location.reload();
    },
    reloadCurrentUser() {
      let currentUser = JSON.parse(localStorage.getItem("currentUser"));
      service.getProfile().then(res => {
        let newUser = res.data;
        if (currentUser && currentUser.user && newUser) {

          currentUser.user.avatar = newUser.avatar;
          currentUser.user.fullName = newUser.fullName;

          currentUser.user.group = newUser.userGroup;
          this.user = Object.assign({}, this.user, currentUser.user);
          localStorage.setItem("currentUser", JSON.stringify(currentUser));
          localStorage.setItem("hotelSync", JSON.stringify(res.data.hotelSync));
        }
      });
    }
  }
};
</script>
